function incrementLastNumber(oid) {
  // Split the OID string by "."
  let parts = oid.split(".");

  let randomIncrement = Math.floor(Math.random() * (999 - 100 + 1)) + 100;

  // Parse and increment the last part
  let lastNumber = parseInt(parts[parts.length - 1]) + randomIncrement;

  // Update the last part (no need for padding in this case)
  parts[parts.length - 1] = lastNumber.toString();

  // Join the parts back into a string and return the result
  return parts.join(".");
}

export default incrementLastNumber
